import React, { useState, useRef, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import ReactPlayer from 'react-player'
import { currencyFormat } from '../../../../../../../utils/Helper'
import _debounce from 'lodash/debounce'
import axiosService from '../../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import Input from '../../../../../../FormComponents/Input'

export default observer(function ActionContentReview({ action, pmSide }) {
  const [selectedUpload, setSelectedUpload] = useState(action.draft_uploads[0])
  const [inputValue, setInputValue] = useState(action.post_url)
  const playerRef = useRef(null)
  const insight = action.action_insight

  const ActionStat = ({ label, value }) => {
    return (
      <div className="flex justify-between border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-md px-2 py-1">
        <p className='text-sm dark:text-gray-400'>{label}</p>
        <p className='text-sm font-bold dark:text-white'>{value}</p>
      </div>
    )
  }
  const price = action.advertiserPrice
  const cpmFollower = price > 0 ? currencyFormat(((price / action.reach) * 1000).toFixed(2), '€') : '0€'  
  const cpmImpression = price > 0 ? currencyFormat(((price / (insight.impressions || insight.story_first_sequence_impressions)) * 1000).toFixed(2), '€') : '0€'
  const postEngRate = ((insight.likes + insight.comments + insight.saves) / action.reach).toFixed(2)
  const costEngRate = price > 0 ? currencyFormat(((price / (insight.likes + insight.comments + insight.saves)).toFixed(2)), '€') : '0€'

  const updateValue = useCallback((newValue) => {
    axiosService.patch(
      `/api/project_manager/campaigns/${action.campaign_id}/actions/${action.id}`, 
      { action_data: { post_url: newValue }})
      .then((resp) => {
        toastSuccess('Post URL updated')
      })
      .catch(({ data: { error } }) => toastError(error))
  }, [action.campaign_id, action.id])

  const debouncedUpdate = useCallback(
    _debounce(updateValue, 1000),
    [updateValue]
  )

  return (
    <div className='border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-lg p-2'>
      <div className="flex items-center justify-between pb-2">
        <h2 className='font-bold dark:text-white'>{action.name}</h2>
        {
          pmSide && (
            <div className='flex items-center gap-2 ml-2'>
              <p className='text-sm dark:text-white'>Post URL</p>
              <Input
                topMargin={false}
                className='ml-2'
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value)
                  debouncedUpdate(e.target.value)
                }}
                />
            </div>
          ) || (
            action.post_url && action.post_url.trim() !== '' && (
              <a href={action.post_url} target='_blank' rel='noopener noreferrer' className='bg-rb-green text-white text-sm font-bold px-2 py-1 rounded-md'>Visit Post</a>
            )
          )
        }
      </div>
      <div className='flex gap-2 items-center'>
        { action.draft_uploads.map(upload => <img key={upload.id} src={upload.videoThumb || upload.url} alt={upload.fileName} className={`w-10 h-10 rounded-md object-cover ${selectedUpload.id === upload.id ? 'border-2 border-rb-green' : ''}`} onClick={() => setSelectedUpload(upload)} />) }
      </div>
      {
        selectedUpload?.videoThumb && (
          <div className='mt-8 h-full w-full rounded-lg flex items-center justify-center'>
            <div className='inline-block rounded-lg overflow-hidden'>
              <ReactPlayer
                ref={playerRef}
                url={selectedUpload.url}
                width='auto'
                height='344px'
                controls={true}
              />
            </div>
          </div>
        ) || (
          <div className='mt-8 h-full w-full rounded-lg flex items-center justify-center'>
            <img src={selectedUpload?.url} alt={selectedUpload?.fileName} className='h-[344px] w-[344px] rounded-md object-cover' />
          </div>
        )
      }
      <div className='mt-8 grid grid-cols-3 gap-2'>
        <ActionStat label='Price' value={currencyFormat(action.advertiserPrice.toFixed(2), '€')} />
        <ActionStat label='CPM Follower' value={cpmFollower} />
        <ActionStat label='CPM Impression' value={cpmImpression} />
      </div>
      <div className='mt-2 grid grid-cols-2 gap-2'>
        <ActionStat label='Eng. Rate' value={postEngRate} />
        <ActionStat label='Cost per Engagement' value={costEngRate} />
      </div>
    </div>
  )
})